import React from "react";
import styled from "styled-components";
import {deviceMax, deviceMin} from "../../../styles/device";

type SubpageHeroAreaWrapperProps = {
    children: React.ReactNode,
    desktopHidden?: boolean,
    career?: boolean
}

const SubpageHeroArea = ({children, career = true, desktopHidden = false}: SubpageHeroAreaWrapperProps) => {
    return (
        <SubpageHeroAreaWrapper career={career} className={desktopHidden ? 'desktop-hidden' : undefined}>
            {children}
        </SubpageHeroAreaWrapper>
    )
}

type IProps = {
    career?: boolean
}

const SubpageHeroAreaWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  width: 100%;
  padding: 57px calc(50% - 575px) 25px;
  box-sizing: border-box;

  &.desktop-hidden {
    display: none;

    @media ${deviceMax.tablet} {
      display: flex;
      justify-content: center;
    }
  }

  @media ${deviceMax.laptop} {
    flex-direction: ${(props: IProps) => props.career ? 'column' : 'row'};
    width: ${(props: IProps) => props.career ? 'calc(100% + 48px)' : '100%'};
    margin-left: ${(props: IProps) => props.career ? '-24px' : '0'};
    align-items: center;
    padding: ${(props: IProps) => props.career ? '15px 5px 0' : '0'};
    height: ${(props: IProps) => props.career ? 'auto' : '93vh'};

    > img {
      width: 100%;
      height: auto;

      &.about-us-mobile-img-top {
        margin-top: -50px;

        @media ${deviceMin.tablet} and ${deviceMax.laptop} {
          max-width: 380px;
          margin-top: 0;
        }
      }

      &.about-us-mobile-img-bottom {
        max-width: 294px;
        rotate: 4deg;
        margin-bottom: -10px;
        margin-left: 50px;
      }

      &.about-us-desktop-img {
        display: none;
      }
    }
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop} {
    height: ${(props: IProps) => props.career ? 'auto' : '60vh'};
  }

  @media ${deviceMax.tablet} {
    flex-direction: ${(props: IProps) => props.career ? 'row' : 'column'};
    padding-top: 70px;
  }

  > .img-wrapper {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media ${deviceMax.laptop} {
      width: 100%;
      max-width: 380px;
      margin-top: 0;
    }

    > .success-stories-desktop-img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  > img {
    &:is(.about-us-mobile-img-top, .about-us-mobile-img-bottom) {
      display: none;

      @media ${deviceMax.laptop} {
        display: block;
      }
    }

    &.about-us-desktop-img {
      display: block;
      width: 100%;
      height: auto;
      max-width: 640px;

      @media ${deviceMax.laptop} {
        display: none;
      }
    }

    @media ${deviceMax.mobileM} {
      &.about-us-mobile-img-bottom {
        max-width: 234px;
      }
    }

    &.career-desktop-img {
      display: block;
      width: 100%;
      height: auto;
      max-width: 696px;
      box-sizing: border-box;
      position: relative;
      padding-top: 74px;
      padding-bottom: 62px;

      @media ${deviceMax.laptop} {
        padding: 0 26px 46px 29px;
      }
    }


  }


  > div {

    @media ${deviceMax.laptop} {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
    }

    > a {
      border-radius: 36px;
      padding-left: 18px;
      padding-right: 18px;
      min-width: 340px;

      @media ${deviceMax.laptop} {
        width: fit-content;
      }

      @media ${deviceMax.mobileM} {
        width: inherit;
        min-width: auto;
        width: inherit;
      }

      > div > div {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }

  > .about-us-desktop-img {
    flex: 1;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: -25px;

    @media ${deviceMax.laptop} {
      display: none;
    }
  }

  > .career-desktop-img {
    flex: 1;
    position: relative;
    display: flex;
    justify-content: center;

    @media ${deviceMax.laptop} {
      padding-left: 20px;
      padding-right: 20px;
    }

    > img {
      width: 100%;
      max-width: 600px;
      max-height: 100%;
      object-fit: contain;
      aspect-ratio: 1/1;

      @media ${deviceMax.mobileL} {
        max-width: 300px;
      }

      @media ${deviceMax.laptop} and ${deviceMin.mobileL} {
        max-width: 360px;
      }
    }
  }
`;

export default SubpageHeroArea;
